import { useAccount } from '../../../common/useAccount'
import { InputParameterHierarchyType } from '../../../components/InputParameterHierarchy/model'
import { LOCK_ALL_OVERRIDE } from '../../../models/Account'
import { InputParametersHierarchyLevel } from '../../../models/InputParametersHierarchy'
import { ReminderType } from '../../../models/Scheduling'
import { type TemplateValue } from '../../../models/TemplateLibrary'
import { useListAccountNodesQuery, useListReminderTemplateChoicesQuery } from '../../../store/ai/inputParametersHierarchy'
import { useGetReminderSettingsQuery } from '../../../store/scheduling/scheduling'
import { useListDetailedTemplatesQuery } from '../../../store/templateLibrary/templateLibrary'
import { REMINDER_EMAIL_SLUG } from '../shared/schedulingEmailCatalog'
import { SCHEDULING_EMAIL_TEMPLATE_TYPE } from '../../Setup/Templates/TemplatesTab'
import { chosenTemplate, preselectedTemplate } from './followUpTemplates'

const FOLLOW_UP_SLUG = REMINDER_EMAIL_SLUG[ReminderType.FOLLOW_UP]
const NO_TEMPLATES: TemplateValue[] = []

export const useFollowUpTemplates = () => {
  const { accountId, account, isLoading: isAccountLoading } = useAccount()
  const isOverrideLocked = account?.enterpriseConfig.lockTemplateOverride === LOCK_ALL_OVERRIDE
  const templatesQuery = useListDetailedTemplatesQuery(
    { accountId, type: SCHEDULING_EMAIL_TEMPLATE_TYPE, typeId: FOLLOW_UP_SLUG, defaultTypeId: FOLLOW_UP_SLUG, scopes: ['system', 'account', 'enterprise'] },
    { refetchOnMountOrArgChange: true },
  )
  const settingsQuery = useGetReminderSettingsQuery({ accountId })
  const followUp = settingsQuery.data?.data.find((settings) => settings.reminderType === ReminderType.FOLLOW_UP)
  const entries =
    followUp?.enabled === true ? followUp.entries.flatMap((entry) => (entry.id != null ? [{ reminderEntryId: entry.id, typeId: FOLLOW_UP_SLUG }] : [])) : []
  const choicesQuery = useListReminderTemplateChoicesQuery(
    { accountId, type: InputParameterHierarchyType.SCHEDULING_EMAIL_TEMPLATE, entries },
    { skip: entries.length === 0 || isAccountLoading || isOverrideLocked },
  )
  const globalChoicesQuery = useListAccountNodesQuery(
    { accountId, type: InputParameterHierarchyType.SCHEDULING_EMAIL_TEMPLATE, level: InputParametersHierarchyLevel.GLOBAL, effective: true },
    { skip: !isOverrideLocked },
  )
  const templates = templatesQuery.data?.data ?? NO_TEMPLATES

  return {
    templates,
    preselected: isOverrideLocked
      ? chosenTemplate(templates, globalChoicesQuery.data?.[FOLLOW_UP_SLUG]?.templateId)
      : preselectedTemplate(templates, followUp, choicesQuery.data ?? {}),
    isLocked: account == null || isOverrideLocked,
    isLoading: isAccountLoading || templatesQuery.isLoading || settingsQuery.isLoading || choicesQuery.isLoading || globalChoicesQuery.isLoading,
    isError: templatesQuery.isError,
    refetchTemplates: templatesQuery.refetch,
  }
}
